<template>
  <div class="container">
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form size="mini" ref="form" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="练习名称:">
              <el-input
                placeholder="请搜索"
                v-model="searchInfo.title"
                @change="handleSearch"
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员姓名:" prop="student_id">
              <el-select
                v-model="searchInfo.student_id"
                filterable
                clearable
                placeholder="请选择"
                @focus="handleStudentNameList('')"
                :filter-method="handleStudentNameList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in studentNameList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="练习状态:" prop="practice_status">
              <el-select
                v-model="searchInfo.practice_status"
                filterable
                clearable
                multiple
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.status_id"
                  :label="item.name"
                  :value="item.status_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="批改人员:" prop="teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布时间:">
              <!-- <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                v-model="searchInfo.expireTimeClass"
                @change="handleSearch"
              >
              </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                v-model="searchInfo.expireTimeClass"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      :data="tableData"
      v-horizontal-scroll
      size="mini"
      tooltip-effect="dark"
      style="width: 100%"
      stripe
      :default-sort="{ prop: 'publish_time', order: 'descending' }"
      @sort-change="clickStort"
    >
      <el-table-column label="练习名称" prop="homework.title">
        <template slot-scope="scope">
          <div class="mwow-green cu-po" @click="goHomeWorkDetail(scope.row)">
            {{ scope.row.homework.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学员姓名" prop="student.name"> </el-table-column>
      <el-table-column label="练习状态" prop="status">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.status === 1" class="mwow-red"> 未发布 </div> -->
          <div
            v-if="scope.row.deadline_status === 2 && scope.row.status === 2"
            class="mwow-red"
          >
            未提交
          </div>
          <div v-else-if="scope.row.status === 3" class="mwow-yellow">
            待批改
          </div>
          <div v-else-if="scope.row.status === 4" class="mwow-green">
            已批改
          </div>
          <div
            v-else-if="
              scope.row.deadline_status === 1 && scope.row.status === 2
            "
            class="mwow-gray"
          >
            已截止
          </div>
          <!-- <div v-else>-</div>
          <div v-if="scope.row.status === 2" class="mwow-red"> 未提交 </div>
          <div v-if="scope.row.status === 3" class="mwow-yellow"> 待批改 </div>
          <div v-if="scope.row.status === 4" class="mwow-green"> 已批改 </div>
          <div v-if="scope.row.status === 5" class="mwow-gray"> 已截止 </div> -->
        </template>
      </el-table-column>
      <el-table-column label="批改人员" prop="corrected_staff">
        <template slot-scope="scope">
          <div v-if="scope.row.corrected_staff !== null">
            {{ scope.row.corrected_staff.name }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" prop="committed_time">
      </el-table-column>
      <el-table-column
        label="发布时间"
        prop="publish_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
    </el-table>
    <div style="height: 50px">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { searchStudent } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import { getHomeworkDetailListApi } from "@/api/homework";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  props: ["visible"],
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        title: "",
        student_id: "",
        expireTimeClass: [],
        teacher_id: "",
        teacher_list: [],
      },
      statusList: [
        {
          status_id: 2,
          name: "未提交",
        },
        {
          status_id: 3,
          name: "待批改",
        },
        {
          status_id: 4,
          name: "已批改",
        },
        {
          status_id: 5,
          name: "已截止",
        },
      ],
      studentNameList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 5,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        pageSize: this.pageSize,
      });
    },
    goHomeWorkDetail(val) {
      if (val.status === 3 || val.status === 4) {
        this.$router.push({
          name: "afterDetails",
          query: {
            id: String(val.homework_id),
            h_s_id: String(val.homework_student_id),
            h_id: String(val.homework_id),
            ddl_status: String(val.deadline_status),
          },
        });
      } else {
        this.$router.push({
          name: "afterDetails",
          query: {
            id: String(val.homework_id),
          },
        });
      }
    },
    handleReset() {
      this.searchInfo = {
        title: "",
        student_id: "",
        expireTimeClass: [],
        teacher_id: "",
        teacher_list: [],
      };
      this.handleSearch();
    },
    getList(val) {
      const option = {
        page: val.page,
        page_size: val.pageSize,
      };
      if (this.searchInfo.title) {
        option.title = this.searchInfo.title;
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.practice_status) {
        option.status = this.searchInfo.practice_status;
      }
      if (this.searchInfo.teacher_id) {
        option.corrected_staff_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.expireTimeClass !== null) {
        option.start_time = this.searchInfo.expireTimeClass[0] / 1000;
        option.end_time =
          (this.searchInfo.expireTimeClass[1] + (24 * 60 * 60 - 1) * 1000) /
          1000;
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        option.sort_field = this.searchInfo.sort_field;
      }
      getHomeworkDetailListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            it.publish_time =
              it.publish_time !== 0
                ? dateFormat("YYYY-mm-dd HH:MM", it.publish_time * 1000)
                : "-";
            it.committed_time =
              it.committed_time !== 0
                ? dateFormat("YYYY-mm-dd HH:MM", it.committed_time * 1000)
                : "-";
          });
          this.page = res.data.page;
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        pageSize: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        pageSize: e,
      });
    },
    handleStudentNameList(v) {
      searchStudent({
        page: 1,
        page_size: 1000,
        key_word: v,
        status: [2],
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentNameList = res.data.list;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
